export const UI_VERSION = '2026.11.1.1';
export const UI_CHANGELOG_PATH = '/changelog';
